import React, { useRef } from 'react'
import { connect } from 'react-redux'
import AnnounceKit from 'announcekit-react'
import { useTranslation } from 'react-i18next';

import CustomButton from '../CustomButton';
import NotificationsMenu from './NotificationsMenu'
import UserAccountMenu from './UserAccountMenu'

import './HeaderNav.sass'

const HeaderNav = (props) => {
	const { user, partnerPortalRedirect } = props
	const userRole = user.roles[0];
	let widgetRef = useRef(null)
	const { t } = useTranslation('translation', { keyPrefix: 'components.headerNav' });
	const announceLink = 'https://updates.roscolive.com/widgets/v2/2Z9pGE'

	React.useEffect(() => {
		widgetRef.current.unread()
			.then(unreadCount => {
				if (unreadCount > 0) {
					widgetRef.current.open()
				}
			})
	}, [widgetRef])

	const redirectUrl = partnerPortalRedirect.portal_url

	return (
		<nav className="header-nav">
			{/* Back to Partner Portal button */}
			{(['partner', 'custom_partner', 'partner_view'].includes(userRole) || redirectUrl) &&
				<CustomButton
					variant="primary"
					style={{ marginRight: '15px' }}
					size="sm"
					onClick={() => location.href = redirectUrl ? `${redirectUrl}${partnerPortalRedirect.type === 'company' ? 'company' : ''}` : redirectUrl}
				>
					{t('btnPartnerPortal')}
				</CustomButton>
			}
			{/* User/Bell notifications */}
			<NotificationsMenu />
			{/* User dropdown menu */}
			<UserAccountMenu />

			<AnnounceKit
				widget={"https://announcekit.co/widgets/v2/2Z9pGE"} // widget key as google APIKey
				onWidgetOpen={() => { }} // Called when the widget is opened.
				ref={widgetRef}
				user={{
					id: user.id,
					email: user.email
				}}
				data={{
					role: user.roles[0]
				}}
				widgetStyle={{
					height: '0.75em',
					top: '13px',
					position: 'absolute',
					left: '48px',
				}}
			/>
		</nav>
	)
}

const mapStateToProps = (state) => {
	return {
		user: state.user.user,
		partnerPortalRedirect: state.partnerPortalRedirect,
	}
}

export default connect(mapStateToProps)(HeaderNav);
